import React from 'react';

import {
  IonApp,
  IonRouterOutlet,
  setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import Dashboard from './pages/Dashboard';
import Auctions from './pages/Auctions';
import Profile from './pages/Profile';
import AuctionsAdmin from './pages/AdminList';

import Auctionsbid from './pages/Auctionsbid';
import Auctionsbook from './pages/Auctionsbook';
import Auctionedit from './pages/Auctionedit';

//AWS Cognito

import { type AuthUser } from "aws-amplify/auth";
import { type UseAuthenticator } from "@aws-amplify/ui-react-core";
import {Authenticator, WithAuthenticatorProps} from '@aws-amplify/ui-react';
import { withAuthenticator} from '@aws-amplify/ui-react';





/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
/* Theme variables */
import './theme/variables.css';
import './theme/app.css';
import {inspect} from "util";

import {Button} from "primereact/button";
import '@aws-amplify/ui-react/styles.css';

import { Redirect, Route } from 'react-router-dom';

type AppProps = {
  signOut?: UseAuthenticator["signOut"]; //() => void;
  user?: AuthUser;
};


setupIonicReact({
  mode: 'md'
});
const App: React.FC<AppProps>  = ({ signOut, user }: WithAuthenticatorProps) => {
    return (
        <>
            <Authenticator>

                    <IonApp>
                        <IonReactRouter>
                            <IonRouterOutlet>
                                <Route exact path="/admin-auctions" sensitive={true}>
                                    <AuctionsAdmin  user={user || {} as AuthUser} signOut={signOut} />
                                </Route>
                                <Route exact path="/dashboard"  sensitive={true}>
                                    <Dashboard user={user || {} as AuthUser}/>
                                </Route>
                                <Route exact path="/auctions"  sensitive={true} >
                                    <Auctions user={user || {} as AuthUser}/>
                                </Route>
                                <Route path="/profile"  sensitive={true}>
                                    <Profile user={user || {} as AuthUser}/>
                                </Route>
                                <Route path="/book-now/:orderID" component={Auctionsbook}  sensitive={true}>
                                </Route>
                                <Route path="/bid/:orderID" component={Auctionsbid}  sensitive={true}>
                                </Route>
                                <Route path="/admin-auction-edit/:orderID" component={Auctionedit}  sensitive={true}>
                                </Route>
                                <Route exact path="/">
                                    <Redirect to="/auctions"/>
                                </Route>
                            </IonRouterOutlet>
                        </IonReactRouter>
                    </IonApp>
            </Authenticator>


        </>
    );
};

export default  withAuthenticator(App);
